export interface ItemType {
    className: string;
    classTag: string;
    description: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;
    name: string;
    tag: string;
    legacy?: boolean;
    deprecated?: boolean;
}

export const isGroupItemType = (type: ItemType): boolean =>
    type.classTag === 'ITEM_GROUPING' || type.classTag === 'MODIFIER_GROUPING'

export const isNonGroupItemType = (type: ItemType): boolean =>
    type.classTag === 'ITEM' || type.classTag === 'MODIFIER'
